import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const WelcomePageLazy = lazyWithRetry(() => import('./WelcomePage'));
export function WelcomePageRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <WelcomePageLazy />
    </Suspense>
  );
}
